import { ExclamationDiamondFill, DiamondFill } from "@styled-icons/bootstrap";

export const newsItemConstants = {
  icon: ExclamationDiamondFill,
  emptyIcon: DiamondFill,
};
